import ByteSizeFormatter from "./ByteSizeFormatter";
export default ByteSizeFormatter;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/utils/ByteSizeFormatter/index.tsx